/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { ReactNode } from "react";
import containerStyle from "./containerStyle";
import { Box, SxProps, Theme } from "@mui/material";
import { sxToArray } from "../../services/utils";

type ContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  sx?: SxProps<Theme>;
  children?: ReactNode;
  sectionPadding?: boolean;
  responsiveWidth?: boolean;
};
const Container = ({ sx = [], children, sectionPadding = true, responsiveWidth = true }: ContainerProps) => {
  const sectionPaddingClass = sectionPadding ? "section" : "noSection";

  return (
    <Box sx={[responsiveWidth ? containerStyle.responsiveContainer : containerStyle.containerBase, containerStyle[sectionPaddingClass], ...sxToArray(sx)]}>
      {children}
    </Box>
  );
};

export default Container;
